<template>
  <transactions-list ref="transactionsList" :data-func="getTransactions" :show-user="true" />
</template>
<script>
  import transactionService from '../../../../services/transaction.service'

  import transactionsList from '../../../common/transactions-list.vue'

  export default {
    name: 'client-trans-bets',
    components: { transactionsList },
    props: {
      provider: {
        type: String,
        required: true
      }
    },
    computed: {
      clientId() {
        return Number(this.$route.params.clientId);
      }
    },
    watch: {
      async provider() {
        await this.$refs.transactionsList.reset();
      }
    },
    methods: {
      async getTransactions(filter) {
        filter.clientId = this.clientId;
        filter.provider = this.provider;
        return await transactionService.get(filter);
      }
    }
  }
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/components/clients/client/bets/trans-bets.vue